import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ActiveContextService } from '@shared/services/active-context.service';
import { AuthService } from '@shared/services/auth.service';

/**
 * Interceptor encargado de adjuntar el identificador de sistema (`x-system-identifier`),
 * `x-business-id` / `x-establishment-id` del contexto activo, y `x-user-id` del usuario
 * logueado (hint de traza; el gateway lo valida y lo reemplaza por el `sub` del token).
 */
export const systemInterceptor: HttpInterceptorFn = (req, next) => {
  const systemIdentifier = environment.systemIdentifier || 'business-admin';
  const contextService = inject(ActiveContextService);
  const authService = inject(AuthService);

  const headersToAdd: Record<string, string> = {
    'x-system-identifier': systemIdentifier,
  };

  const activeBusiness = contextService.activeBusiness();
  if (activeBusiness?._id && activeBusiness._id !== 'ALL') {
    headersToAdd['x-business-id'] = activeBusiness._id;
  }

  const activeEstablishment = contextService.activeEstablishment();
  if (activeEstablishment?._id) {
    headersToAdd['x-establishment-id'] = activeEstablishment._id;
  }

  const user = authService.currentUser();
  const userId = user?.id || user?._id;
  if (userId) {
    headersToAdd['x-user-id'] = userId;
  }
  const userName =
    user?.fullName?.trim() ||
    `${user?.firstName || ''} ${user?.lastName || ''}`.trim() ||
    user?.name ||
    user?.username;
  if (userName) {
    headersToAdd['x-user-name'] = encodeURIComponent(userName);
  }

  // Limpiar parámetros de query vacíos o "undefined"/"null"
  let params = req.params;
  for (const key of params.keys()) {
    const val = params.get(key);
    if (val === undefined || val === null || val === '' || val === 'undefined' || val === 'null') {
      params = params.delete(key);
    }
  }

  const clonedReq = req.clone({
    setHeaders: headersToAdd,
    params,
  });

  return next(clonedReq);
};
